import { shouldDisplayWithHideWhen } from 'layout/utils-hide-when.js';
import { ScreenSizeContext } from 'page-context/column-layout/column-layout-context.js';
import { memo, useContext } from 'react';
import { AdComponent } from 'redux-state/advertisement/types.js';
import { AdvertInterstitial } from '../advert/advert-interstitial.js';

/** Interstitial Display Component */
const InterstitialPortalCore = ({ interstitialPayload }: { interstitialPayload?: AdComponent }): JSX.Element | null => {
  const columnLayout = useContext(ScreenSizeContext);

  const displayInterstitial = shouldDisplayWithHideWhen(interstitialPayload?.layout, columnLayout);

  if (displayInterstitial && interstitialPayload) {
    return <AdvertInterstitial {...interstitialPayload} />;
  }

  return null;
};

export const InterstitialPortal = memo(InterstitialPortalCore);
